import { ILoggingAPIBody, ILoggingAPIsuccessResposnse } from "../../logging/types/LoggingTypes";
import { UserDimensions } from "../../logging/dimensions/UserDimensions";
import Api from "../api";

export default(
    body: ILoggingAPIBody[],
): Promise<ILoggingAPIsuccessResposnse> => {
    const url = `${process.env.REACT_APP_NEXT_PUBLIC_LOGGING_URL_CLIENT || "https://sooqdev1.com/api/logging/v1"}`;
    const bodyWithGclid = body.map((payload) => ({
        ...payload,
        User_gclid: payload.User_gclid || UserDimensions.getInstance().userGclid,
    }));

    return Api.getInstance().request.post(url, bodyWithGclid, url);
};

